import React from "react";

// Assets
import * as FiIcons from "react-icons/fi";
import * as RiIcons from "react-icons/ri";
import * as HiIcons from "react-icons/hi";
import * as MdIcons from "react-icons/md";
import RcsIcon from "../components/icons/RcsIcon";
export const SideBarData = [
  {
    title: "Inicio",
    path: "/Home",
    isPartnerRoute: true,
    roles: [2, 3],
    isAdminRoute: false,
    icon: <FiIcons.FiHome />,
  },
  {
    title: "Inicio",
    path: "/Home",
    isPartnerRoute: false,
    roles: [1, 4, 5],
    isAdminRoute: true,
    icon: <FiIcons.FiHome />,
  },
  {
    title: "Dashboard",
    isPartnerRoute: false,
    roles: [1],
    isAdminRoute: true,
    icon: <MdIcons.MdOutlineSpaceDashboard />,
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,
    subNav: [
      {
        title: "SMS",
        path: "/dashboard/sms",
        isPartnerRoute: false,
        isAdminRoute: true,
        roles: [1],
      },
      {
        title: "RCS",
        path: "/dashboard/rcs",
        isPartnerRoute: false,
        isAdminRoute: true,
        roles: [1],
      },
    ],
  },
  {
    title: "Clientes",
    path: "/dashboard/customers",
    isPartnerRoute: false,
    roles: [1],
    isAdminRoute: true,
    icon: <RiIcons.RiContactsLine />,
  },
  {
    title: "API sms",
    path: "/Sms",
    isPartnerRoute: true,
    roles: [2, 3],
    isAdminRoute: false,
    icon: <RiIcons.RiChat4Line />,
  },
  {
    title: "Configuración",
    isPartnerRoute: false,
    isAdminRoute: true,
    roles: [1],
    icon: <FiIcons.FiSliders />,
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,
    subNav: [
      {
        title: "Clientes",
        path: "/administration/Customers",
        isPartnerRoute: false,
        isAdminRoute: true,
        roles: [1],
        icon: <FiIcons.FiUserCheck />,
      },
      {
        title: "Marcaciones",
        path: "/administration/shortcodes",
        isPartnerRoute: false,
        isAdminRoute: true,
        roles: [1],
        icon: <FiIcons.FiPhoneCall />,
      },
      {
        title: "Mascaras Marcaciones",
        path: "/administration/shortcodesmasks",
        isPartnerRoute: false,
        isAdminRoute: true,
        roles: [1],
        icon: <FiIcons.FiPhoneCall />,
      },
      {
        title: "Keywords",
        path: "/administration/keywords",
        isPartnerRoute: false,
        isAdminRoute: true,
        roles: [1],
        icon: <FiIcons.FiPhoneCall />,
      },
      // {
      //   title: "Paquetes de SMS",
      //   path: "/administration/smsPackages",
      //   isPartnerRoute: false,
      //   isAdminRoute: true,
      //   icon: <FiIcons.FiUserCheck />,
      // },
      {
        title: "Tarifas de SMS",
        path: "/Configuration/DefaultPrices",
        isAdminRoute: true,
        roles: [1],
        icon: <FiIcons.FiUserCheck />,
      },
    ],
  },

  {
    title: "Usuarios",
    isPartnerRoute: true,
    isAdminRoute: false,
    roles: [2],
    icon: <RiIcons.RiUserSettingsLine />,
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,
    subNav: [
      {
        title: "Usuarios",
        path: "/Administration/Users",
        isPartnerRoute: true,
        roles: [2],
        isAdminRoute: false,
        icon: <FiIcons.FiUsers />,
      },
    ],
  },
  {
    title: "Usuarios",
    isPartnerRoute: false,
    isAdminRoute: true,
    roles: [1],
    icon: <RiIcons.RiUserSettingsLine />,
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,
    subNav: [
      {
        title: "Usuarios Operativos",
        path: "/Administration/staff",
        isPartnerRoute: false,
        isAdminRoute: true,
        roles: [1],
        icon: <FiIcons.FiUsers />,
      },
    ],
  },
  {
    title: "Herramientas",
    isPartnerRoute: false,
    isAdminRoute: true,
    roles: [1, 5],
    icon: <RiIcons.RiToolsLine />,
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,
    subNav: [
      {
        title: "Urls Cortas",
        path: "Administration/ShortLinks",
        isPartnerRoute: false,
        isAdminRoute: true,
        roles: [1, 5],
        icon: <FiIcons.FiDatabase />,
      },
    ],
  },
  {
    title: "Herramientas",
    isPartnerRoute: true,
    isAdminRoute: false,
    roles: [2, 3],
    icon: <RiIcons.RiToolsLine />,
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,
    subNav: [
      {
        title: "Urls Cortas",
        path: "/ShortLinks",
        isPartnerRoute: true,
        roles: [2, 3],
        isAdminRoute: false,
        icon: <FiIcons.FiDatabase />,
      },
      {
        title: "Plantillas Mensajes RCS",
        path: "/RCS/MessageTemplates",
        isPartnerRoute: true,
        roles: [2, 3],
        isAdminRoute: false,
        icon: <FiIcons.FiDatabase />,
        channel: "RCS"
      }
    ],
  },
  {
    title: "Contactos",
    isPartnerRoute: false,
    isAdminRoute: true,
    roles: [1, 5],
    icon: <RiIcons.RiContactsBook2Line />,
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,
    subNav: [
      {
        title: "Grupo de contactos",
        path: "Contacts/ContactsDatabase",
        isPartnerRoute: true,
        roles: [1, 5],
        isAdminRoute: false,
        icon: <FiIcons.FiDatabase />,
      },
    ],
  },
  {
    title: "Contactos",
    isPartnerRoute: true,
    isAdminRoute: false,
    roles: [2, 3],
    icon: <RiIcons.RiContactsBook2Line />,
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,
    subNav: [
      {
        title: "Grupo de contactos",
        path: "Db/ContactsDatabase",
        isPartnerRoute: true,
        roles: [2, 3],
        isAdminRoute: false,
        icon: <FiIcons.FiDatabase />,
      },
    ],
  },
  {
    title: "Campaña",
    isPartnerRoute: true,
    isAdminRoute: false,
    roles: [2, 3],
    icon: <HiIcons.HiOutlineSpeakerphone />,
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,
    subNav: [
      {
        title: "Campañas",
        path: "/Campaigns",
        isPartnerRoute: true,
        roles: [2, 3],
        isAdminRoute: false,
        icon: <RiIcons.RiLineChartLine />,
      },
      // {
      //   title: "Nueva Campaña V1",
      //   path: "/Campaigns/NewCampaignMulti",
      //   isPartnerRoute: false,
      //   roles: [1, 5],
      //   isAdminRoute: true,
      //   icon: <RiIcons.RiLineChartLine />,
      // },
      {
        title: "Nueva Campaña",
        path: "/Campaigns/NewCampaign/multi",
        isPartnerRoute: false,
        roles: [1, 5],
        isAdminRoute: true,
        icon: <RiIcons.RiLineChartLine />,
      },
      {
        title: "Nueva Campaña RCS",
        path: "/Campaigns/NewCampaignRcs",
        isPartnerRoute: false,
        roles: [1, 5],
        channel: "RCS",
        isAdminRoute: true,
        icon: <RcsIcon width={20} height={20} />,
      },
    ],
  },
  {
    title: "Campaña",
    isPartnerRoute: false,
    isAdminRoute: true,
    roles: [1, 5],
    icon: <HiIcons.HiOutlineSpeakerphone />,
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,
    subNav: [
      {
        title: "Campañas",
        path: "/Administration/Campaigns",
        isPartnerRoute: false,
        roles: [1, 5],
        isAdminRoute: true,
        icon: <RiIcons.RiLineChartLine />,
      },
    ],
  },
  {
    title: "Dos vías",
    isPartnerRoute: true,
    isAdminRoute: false,
    roles: [2, 3],
    icon: <RiIcons.RiQuestionAnswerLine />,
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,
    subNav: [
      {
        title: "Mensajes Mo",
        path: "/Reports/ReportMoDate",
        roles: [2, 3],
        isPartnerRoute: true,
        isAdminRoute: false,
        icon: <FiIcons.FiUser />,
      },
    ],
  },
   {
    title: "Reportes",
    path: "AdminReports",
    isPartnerRoute: false,
    roles: [1],
    isAdminRoute: true,
    icon: <MdIcons.MdOutlineAnalytics />,
  },
   {
    title: "Reportes",
    path: "Reports",
    isPartnerRoute: false,
    roles: [2, 3],
    isAdminRoute: false,
    icon: <MdIcons.MdOutlineAnalytics />,
  },
  {
    title: "Monitor",
    path: "/dashboard/monitor",
    isPartnerRoute: false,
    roles: [1],
    isAdminRoute: true,
    icon: <MdIcons.MdMonitor />,
  },
];
